import * as classNames from 'classnames'
import { Field, Formik, Form } from 'formik'
import * as React from 'react'
import * as Yup from 'yup'

import { IServiceGroupRideRadiusUpdate, IServiceObject, IStoreState } from '../../../types/index'
import UIMessages from 'src/utils/ui-messages'

interface IServiceEditGroupRideInfoProps {
  serviceId?: string
  groupRideInfo: any
  formRef: any
  onComponentSubmit: (service: IServiceGroupRideRadiusUpdate) => Promise<IServiceObject>
  onStepSuccessfullyCompleted?: () => void
  onComponentMount: () => void
}

const validationSchema = Yup.object().shape({
  ondemandGridePickupRadius: Yup.number()
    .min(1, 'Ondemand group ride pickup radius must be greater than 1')
    .required(),
  ondemandGrideDropoffRadius: Yup.number()
    .min(1, 'Ondemand group ride dropoff radius must be greater than 1')
    .required(),
  scheduledGridePickupRadius: Yup.number()
    .min(1, 'Scheduled group ride pickup radius must be greater than 1')
    .required(),
  scheduledGrideDropoffRadius: Yup.number()
    .min(1, 'Scheduled group ride dropoff radius must be greater than 1')
    .required(),
  scheduledGridePickupTime: Yup.number()
    .min(1, 'Scheduled group ride dropoff Time must be greater than 1')
    .required(),
  scheduledGrideDropoffTime: Yup.number()
    .min(1, 'Scheduled group ride dropoff Time must be greater than 1')
    .required()
})

class ServiceEditGroupRideSettings extends React.Component<IServiceEditGroupRideInfoProps, IStoreState> {
  constructor(props: IServiceEditGroupRideInfoProps) {
    super(props)
  }

  public componentDidMount() {
    this.props.onComponentMount()
  }
  public handleSubmit(service: any) {
    const onStepSuccessfullyCompleted = this.props.onStepSuccessfullyCompleted
    this.props.onComponentSubmit(service).then(
      (service: IServiceObject) => {
        return onStepSuccessfullyCompleted && onStepSuccessfullyCompleted()
      },
      error => console.log('error:', error)
    )
  }
  public render() {
    let { groupRideInfo } = this.props

    if (!groupRideInfo) {
      groupRideInfo = {
        ondemandGridePickupRadius: 0,
        ondemandGrideDropoffRadius: 0,
        scheduledGridePickupRadius: 0,
        scheduledGrideDropoffRadius: 0,
        scheduledGridePickupTime: 0,
        scheduledGrideDropoffTime: 0,
        allowGroupingDifferentProducts: false
      }
    }
    const initiaValues: IServiceGroupRideRadiusUpdate = {
      id: '',
      ondemandGridePickupRadius: groupRideInfo.ondemandGridePickupRadius,
      ondemandGrideDropoffRadius: groupRideInfo.ondemandGrideDropoffRadius,
      scheduledGridePickupRadius: groupRideInfo.scheduledGridePickupRadius,
      scheduledGrideDropoffRadius: groupRideInfo.scheduledGrideDropoffRadius,
      scheduledGridePickupTime: groupRideInfo.scheduledGridePickupTime,
      scheduledGrideDropoffTime: groupRideInfo.scheduledGrideDropoffTime,
      allowGroupingDifferentProducts: groupRideInfo.allowGroupingDifferentProducts
    }
    return (
      <Formik
        ref={this.props.formRef}
        enableReinitialize={true}
        initialValues={initiaValues}
        validationSchema={validationSchema}
        onSubmit={(e: IServiceGroupRideRadiusUpdate) => {
          if (this.props.serviceId) {
            e.id = this.props.serviceId
            this.handleSubmit(e)
          }
        }}
      >
        {({ touched, errors }: any) => (
          <Form>
            <div className='ServiceEditMainInfo flex flex-column p2 mb4'>
              <div className='mt2 h4 font-blue-grey'>{UIMessages.service.groupRide} Radius</div>
              <div className='col col-6 mt3 '>
                <div className='col col-12 pr1'>
                  <label className='h5 font-dark-grey block'>
                    {UIMessages.service.groupSettingLabels.ondemandPickupRadius}
                  </label>
                  <Field
                    name='ondemandGridePickupRadius'
                    type='number'
                    placeholder='ondemandPickupRadius'
                    className={classNames('rounded p1 block', {
                      'border-light-grey4': !(touched.ondemandGridePickupRadius && errors.ondemandGridePickupRadius),
                      'border-red focus-red': touched.ondemandGridePickupRadius && errors.ondemandGridePickupRadius
                    })}
                  />
                  <div className='mb2'>
                    {touched.ondemandGridePickupRadius && errors.ondemandGridePickupRadius && (
                      <span className='h6 font-red'>{errors.ondemandGridePickupRadius}</span>
                    )}
                  </div>
                </div>

                <div className='col col-12 pr1'>
                  <label className='h5 font-dark-grey block'>
                    {UIMessages.service.groupSettingLabels.ondemandDropoffRadius}
                  </label>
                  <Field
                    name='ondemandGrideDropoffRadius'
                    type='number'
                    placeholder='ondemandGrideDropoffRadius'
                    className={classNames('rounded p1 block', {
                      'border-light-grey4': !(touched.ondemandGrideDropoffRadius && errors.ondemandGrideDropoffRadius),
                      'border-red focus-red': touched.ondemandGrideDropoffRadius && errors.ondemandGrideDropoffRadius
                    })}
                  />
                  <div className='mb2'>
                    {touched.ondemandGrideDropoffRadius && errors.ondemandGrideDropoffRadius && (
                      <span className='h6 font-red'>{errors.ondemandGrideDropoffRadius}</span>
                    )}
                  </div>
                </div>

                <div className='col col-12 pr1'>
                  <label className='h5 font-dark-grey block'>
                    {UIMessages.service.groupSettingLabels.scheduledPickupRadius}
                  </label>
                  <Field
                    name='scheduledGridePickupRadius'
                    type='number'
                    placeholder='scheduledGridePickupRadius'
                    className={classNames('rounded p1 block', {
                      'border-light-grey4': !(touched.scheduledGridePickupRadius && errors.scheduledGridePickupRadius),
                      'border-red focus-red': touched.scheduledGridePickupRadius && errors.scheduledGridePickupRadius
                    })}
                  />
                  <div className='mb2'>
                    {touched.scheduledGridePickupRadius && errors.scheduledGridePickupRadius && (
                      <span className='h6 font-red'>{errors.scheduledGridePickupRadius}</span>
                    )}
                  </div>
                </div>

                <div className='col col-12 pr1'>
                  <label className='h5 font-dark-grey block'>
                    {UIMessages.service.groupSettingLabels.scheduledDropoffRadius}
                  </label>
                  <Field
                    name='scheduledGrideDropoffRadius'
                    type='number'
                    placeholder='scheduledGrideDropoffRRadius'
                    className={classNames('rounded p1', {
                      'border-light-grey4': !(
                        touched.scheduledGrideDropoffRadius && errors.scheduledGrideDropoffRadius
                      ),
                      'border-red focus-red': touched.scheduledGrideDropoffRadius && errors.scheduledGrideDropoffRadius
                    })}
                  />
                  <div className='mb2'>
                    {touched.scheduledGrideDropoffRadius && errors.scheduledGrideDropoffRadius && (
                      <span className='h6 font-red'>{errors.scheduledGrideDropoffRadius}</span>
                    )}
                  </div>
                </div>

                <div className='col col-12 pr1'>
                  <label className='h5 font-dark-grey block'>
                    {UIMessages.service.groupSettingLabels.scheduledPickupTime}
                  </label>
                  <Field
                    name='scheduledGridePickupTime'
                    type='number'
                    placeholder='scheduledGridePickupTime'
                    className={classNames('rounded p1 block', {
                      'border-light-grey4': !(touched.scheduledGridePickupTime && errors.scheduledGridePickupTime),
                      'border-red focus-red': touched.scheduledGridePickupTime && errors.scheduledGridePickupTime
                    })}
                  />
                  <div className='mb2'>
                    {touched.scheduledGridePickupTime && errors.scheduledGridePickupTime && (
                      <span className='h6 font-red'>{errors.scheduledGridePickupTime}</span>
                    )}
                  </div>
                </div>

                <div className='col col-12 pr1'>
                  <label className='h5 font-dark-grey block'>
                    {UIMessages.service.groupSettingLabels.scheduledDropoffTime}
                  </label>
                  <Field
                    name='scheduledGrideDropoffTime'
                    type='number'
                    placeholder='scheduledGrideDropoffTime'
                    className={classNames('rounded p1', {
                      'border-light-grey4': !(touched.scheduledGrideDropoffTime && errors.scheduledGrideDropoffTime),
                      'border-red focus-red': touched.scheduledGrideDropoffTime && errors.scheduledGrideDropoffTime
                    })}
                  />
                  <div className='mb2'>
                    {touched.scheduledGrideDropoffTime && errors.scheduledGrideDropoffTime && (
                      <span className='h6 font-red'>{errors.scheduledGrideDropoffTime}</span>
                    )}
                  </div>

                  <div className='col col-12 pr1'>
                    <label className='h5 font-dark-grey block'>
                      <Field name='allowGroupingDifferentProducts'>
                        {({ field }: any) => <input type='checkbox' {...field} checked={field.value} className='mr1' />}
                      </Field>
                      {UIMessages.service.groupSettingLabels.allowGroupingDifferentProducts}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    )
  }
}

export default ServiceEditGroupRideSettings



// WEBPACK FOOTER //
// ./src/components/services/edit/ServiceEditGroupRideSettings.tsx